<div class="container-fluid">
  <div class="row">
    <div class="col-xl-12">
      <h1 class="page-hd">Associate <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Add Record </h1>
      <div class="content-wrap">
        <div class="row">
          <div class="col-md-2">
            <h3 class="page-subhd">Auto Upload Excel from S3</h3>
            <button class="proceed-btn2" (click)="funAutoReadExcel()" data-toggle="modal" data-target="#confirmModal">ScanData</button>

          </div>

          <div class="col-md-2">
            <!--  <img src="assets/images/or_img.png" class="dot-line" alt="img">
           <p class="dot-line"> ----------------------------------------------------------------------------------------------------------------------------------------- OR -----------------------------------------------------------------------------------------------------------------------------------------</p> -->
            <p class="or-txt">OR</p>
          </div>
          <div class="col-md-4">
            <div class="col-md-12">
              <h3 class="page-subhd">Upload student excel sheet with student data <span class="font100">(Upto 750KB)</span></h3>                      
              <div *ngIf="emptyExcel">
                <p style="color:#dc3545;font-size:100% ;">Please check your Excel, maybe excel format is wrong.</p>
              </div>
            </div>
            
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                <!-- <label for="userName" class="form-label">Upload Student Data Excel (Upto 750KB)</label> -->
                <input type="file" #inputFile1 class="form-control form-input border-none" id="uploadExcel"
                  (change)="catchExcel($event)" accept=".xls,.xlsx">
                <div *ngIf="excelSizeErr">
                  <p style="color:#dc3545;font-size:100% ;">File size must be less than 750KB.</p>
                </div>
                <div *ngIf="enterExcelErr">
                  <p style="color:#dc3545;font-size:100% ;">Please enter student Excel File.</p>
                </div>
                <div class="invalid-feedback">
                  <div>Student data is required</div>
                </div>
              </div>
              <a class="proceed-btn2 display-in-bl mt-2" href="/University/assets/images/AssociateUpload.xlsx">Download Sample Excel</a>
            </div>
          </div>
        
          <div class="col-md-4">
          <div class="col-md-12">
            <h3 class="page-subhd">Upload student file with student marks <span class="font100">(Upto 750KB)</span></h3>
          </div>
          <div class="col-md-12">
            <div class="form-group input-group-lg">
              <!-- <label for="userEmail" class="form-label">User Student Marks image (Upto 750KB)</label> -->
              <input type="file" #inputFile2 class="form-control form-input border-none" id="uploadPDF"
                (change)="catchPdf($event)" accept=".png,.jpg,.jpeg,.tiff,.pdf">
                <!-- <input type="file" (change)="pdfOnload($event)" id='pdf-upload' accept=".pdf,.jpg,.png" multiple="false" /> -->
              <div class="invalid-feedback">
                <div>Marks PDF is required</div>
              </div>
              <div *ngIf="pdfSizeErr">
                <p style="color:#dc3545;font-size:100% ;">File size must be less than 750KB.</p>
              </div>
              <div *ngIf="enterMarksErr">
                <p style="color:#dc3545;font-size:100% ;">Please enter student Marks File.</p>
              </div>
            </div>
          </div>
          <button class="proceed-btn bg-theme pull-right" (click)="reviewRecord()" data-toggle="modal"
          data-target="#confirmModal">Add Record</button>
        </div>
      </div>
       
        
      </div>
    </div>
    <div class="col-md-12" id="previewModal">
      <div *ngIf="showExcelPreview" class="modal-dialog" role="document" >
        <div class="modal-content">
          <div class="modal-header bg-theme1">
            <h5 class="modal-title" id="viewModalLabel">Data Preview</h5>
          </div>
          <div class="modal-body modal-body-border">
            <div class="row">
              <div class="col-md-6">
                <div class="table-responsive">
                  <table class="ui celled table hover" id="previewTable">
                    <thead>
                      <tr>
                        <!-- <th>Student Name</th>
                              <th>Student Surname</th> -->
                        <th>Seat Number</th>
                        <th>Stream</th>
                        <!-- <th>Branch</th> -->
                        <th>Semester</th>
                        <th>Passing Year</th>
                        <!-- <th>College Name</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let data of reviewedData">
                        <!-- <td>{{data.firstName}}</td>
                                 <td>{{data.lastName}}</td> -->
                        <td>{{data.enrollmentNo}}</td>
                        <td>{{data.stream}}</td>
                        <!-- <td>{{data.branch_nm}}</td> -->
                        <td>{{data.semester}}</td>
                        <td>{{data.monthOfPassing}}/{{data.passingYear}}</td>
                        <!-- <td>{{data.collegeName}}</td>                            -->
                      </tr>
                    </tbody>
                  </table>
                </div>
    
               
                <button [disabled]="allowConfirm" class="proceed-btn bg-theme" data-toggle="modal" (click)="confirmData()"
                  data-target="#confirmData">Save data</button>
                <button class="reject-modal-btn mr-auto" data-dismiss="modal" (click)="cancelData()">Cancel</button>
              </div>
              <div class="col-md-6">
                <p class="doc-txt1">Preview</p>
    
                <div *ngIf="showImagePrev">
                  <div class="doc-img-wrap">
                    <img *ngIf="imageUrl" [src]="imageUrl" alt="Certificate" class="doc-img1">
                  </div>
                 
                </div>
                <div *ngIf="showPdfPrev">
                  <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="true">
                  </pdf-viewer>
                </div>
    
                <!-- <img *ngIf="imageUrl" [src]="imageUrl" alt="Certificate" class="doc-img"> -->
    
                
                <!-- <div *ngIf="isUPdf">
                  <div class="ng-star-inserted22">
                    <pdf-viewer [src]="imageUrl" [zoom]="1"></pdf-viewer>
                    <pdf-viewer *ngIf="imageUrl" [src]="imageUrl" [zoom]="1"></pdf-viewer>
                  </div>
                  <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
                </div>
                <div *ngIf="isUImage">
                  <img [src]="imageUrl" class="doc-img" (click)="showLightbox(0)" loading="lazy">
                </div> -->
    
                <!-- <img *ngIf="imageUrl" [src]="imageUrl" alt="Certificate" class="doc-img"> -->
                <!-- <pdf-viewer *ngIf="imageUrl" [src]="imageUrl" [zoom]="1"></pdf-viewer> -->
                <!-- <pdf-viewer [src]="pdfSrc" [render-text]="true" class="doc-img" style="display: block;"></pdf-viewer> -->
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>



<div class="modal fade" *ngIf="IsmodelShowSecond" id="confirmData" tabindex="-1" role="dialog"
  aria-labelledby="viewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Confirm Data</h5>
        <button type="button" class="close" #closebutton2 data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <h3 class="page-subhd1">Uploaded Records</h3>
            <div class="table-responsive">
              <table class="ui celled table hover">
                <thead>
                  <tr>
                    <!-- <th>Student Name</th>
                          <th>Student Surname</th> -->
                    <th>Seat Number</th>
                    <th>Stream</th>
                    <!-- <th>Branch</th> -->
                    <th>Semester</th>
                    <th>Passing Year</th>
                    <!-- <th>College Name</th> -->

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of acceptedData">
                    <!-- <td>{{data.firstName}}</td>
                          <td>{{data.lastName}}</td> -->
                    <td>{{data.enrollmentNo}}</td>
                    <td>{{data.stream}}</td>
                    <!-- <td>{{data.branch_nm}}</td> -->
                    <td>{{data.semester}}</td>
                    <!-- <td>{{data.passingYear}}</td> -->
                    <td>{{data.monthOfPassing}}/{{data.passingYear}}</td>
                    <!-- <td>{{data.collegeName}}</td> -->

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-12">
            <h3 class="page-subhd2">Rejected Records</h3>
            <div class="table-responsive">
              <table class="ui celled table hover">
                <thead>
                  <tr>
                    <!-- <th>Student Name</th>
                          <th>Student Surname</th> -->
                    <th>Seat Number</th>
                    <th>Stream</th>
                    <!-- <th>Branch</th> -->
                    <th>Semester</th>
                    <th>Passing Year</th>
                    <!-- <th>College Name</th> -->
                    <th>Reason</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of rejectedData">
                    <!-- <td>{{data.firstName}}</td>
                        <td>{{data.lastName}}</td> -->
                    <td>{{data.enrollmentNo}}</td>
                    <td>{{data.stream}}</td>
                    <!-- <td>{{data.branch_nm}}</td> -->
                    <td>{{data.semester}}</td>
                    <td>{{data.monthOfPassing}}/{{data.passingYear}}</td>
                    <!-- <td>{{data.collegeName}}</td> -->
                    <td>{{data.reason}}</td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <button class="proceed-btn bg-theme" (click)="closeAll()">Ok</button>
      </div>
    </div>
  </div>
</div>

<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{scanMsg}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>

</ng-template>

<ng-template #showModalBox1 class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <!-- <h3 class="success-text">Failure</h3> -->
                    <p class="reset-hd2">Scan is already going on, Please try after sometime.</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refreshClose()">Done</button>
        </div>
    </div>

</ng-template>